import { useMutation } from '@tanstack/react-query';
import useFetchHelpCenter from 'app/hooks/fetch/useFetchHelpCenter';
import { FormSubmitPayload, submitContactForm } from 'app/services/contactForm';
import queryClient from 'app/services/queryClient';

import { CONTACT_FORM_QUERY_KEY, ContactFormResponse } from './useContactForm';

export default function useContactFormSubmit(contactFormSlug?: string) {
  const { data } = useFetchHelpCenter();
  const uuid = data?.uuid;

  return useMutation({
    mutationKey: ['contact-form-submit'],
    mutationFn: async (payload: FormSubmitPayload) => {
      const data = await submitContactForm(uuid!, payload, contactFormSlug);

      const isLast = data.chat_items.length === 0;

      queryClient.setQueryData([CONTACT_FORM_QUERY_KEY, contactFormSlug], (oldData: ContactFormResponse) => ({
        ...oldData,
        chat_items: isLast ? data.forms : data.chat_items,
      }));

      return data;
    },
  });
}
